// @ts-nocheck
export const ENTITY_DETAILS_QUERY_KEY = [
  'entityDetails',
  'entityDetailsRestApi', //temporary key will remove after query implemnentation in old view
];

export const IS_ENTITY_AVAILABLE_QUERY_KEY = [
  'entityDetails',
  'isEntityAvailable',
];

export const ENTITY_TYPE_METADATA_QUERY_KEY = [
  'entityDetails',
  'entityTypeMetadata',
];

export const ENTITY_META_DATA_QUERY_KEY = [
  'entityDetails',
  'entityDetailsRestApi',
  'entityMetaData',
];

export const STATE_DETAILS_QUERY_KEY = [
  'entityDetails',
  'entityDetailsRestApi',
  'stateDetails',
];

export const ATTRIBUTE_COMMENTS_QUERY_KEY = [
  'entityDetails',
  'entityDetailsRestApi',
  'attributeComments',
];

export const ENTITY_TYPE_COUNTS_QUERY_KEY = [
  'entityDetails',
  'entityDetailsRestApi',
  'entityTypeCounts',
];

export const CUSTOM_ENTITY_LIST_QUERY_KEY = [
  'entityDetails',
  'entityDetailsRestApi',
  'customEntityList',
];

export const ATTRIBUTE_LIST_QUERY_KEY = [
  'entityDetails',
  'entityDetailsRestApi',
  'attributeList',
  'systemGeneratedAttribute',
];

export const DRAFT_ATTRIBUTE_VALUE_QUERY_KEY = [
  'entityDetails',
  'entityDetailsRestApi',
  'attributeList',
  'draftAttributeValue',
  'attributeListData',
];

export const OVERRIDE_ATTRIBUTE_VALUE_QUERY_KEY = [
  'entityDetails',
  'entityDetailsRestApi',
  'attributeList',
  'overrideAttributeValue',
  'attributeListData',
];

export const SET_DRAFT_ATTRIBUTE_VALUE_QUERY_KEY = [
  'entityDetails',
  'entityDetailsRestApi',
  'attributeList',
  'draftAttributeValue',
  'setDraftAttributeValue',
  'attributeListData',
];

export const ATTRIBUTE_LIST_DATA_QUERY_KEY = [
  'entityDetails',
  'entityDetailsRestApi',
  'attributeList',
  'attributeListData',
];

export const ENTITY_SECTION_PERMISSIONS_QUERY_KEY = [
  'entityDetails',
  'entityDetailsRestApi',
  'sectionPermissions',
];

export const SINGLE_ENTITY_QUERY_KEY = [
  'entityDetails',
  'entityDetailsRestApi',
  'singleEntity',
];

export const TEAM_DETAILS_QUERY_KEY = [
  'entityDetails',
  'entityDetailsRestApi',
  'teamDetails',
];

export const GROUP_DETAILS_QUERY_KEY = [
  'entityDetails',
  'entityDetailsRestApi',
  'groupDetails',
];

export const SINGLE_ENTITY_DETAILS_QUERY_KEY = [
  'entityDetails',
  'entityDetailsRestApi',
  'singleEntityDetails',
];

export const USER_ROLE_PERMISSIONS_QUERY_KEY = [
  'entityDetails',
  'entityDetailsRestApi',
  'userRolePermissions',
];

export const ARTIFACT_PROCESS_STATUS_QUERY_KEY = [
  'entityDetails',
  'entityDetailsRestApi',
  'artifactProcessStatus',
];

export const IS_CYCLE_PROCESS_ENABLED_QUERY_KEY = [
  'entityDetails',
  'entityDetailsRestApi',
  'isCycleProcessEnabled',
];

export const CYCLE_PROCESS_DETAILS_QUERY_KEY = [
  'entityDetails',
  'entityDetailsRestApi',
  'cycleProcessDetails',
];

export const UPDATE_CYCLE_COUNT_QUERY_KEY = [
  'entityDetails',
  'entityDetailsRestApi',
  'cycleProcessHistory',
];

export const TOOLBAR_BY_ID_QUERY_KEY = [
  'entityDetails',
  'entityDetailsRestApi',
  'toolbarById',
];

export const MODEL_PREVIOUS_STATE_QUERY_KEY = [
  'entityDetails',
  'entityDetailsRestApi',
  'modelPreviousState',
];

export const ALERT_EVENTS_QUERY_KEY = [
  'entityDetails',
  'entityDetailsRestApi',
  'alertEvents',
];

export const APPROVAL_DETAILS_QUERY_KEY = [
  'entityDetails',
  'entityDetailsRestApi',
  'approvalDetails',
];

export const WORKFLOW_CHECKLIST_QUERY_KEY = [
  'entityDetails',
  'entityDetailsRestApi',
  'workflowChecklist',
];

export const SUMMARY_SECTION_DETAILS_QUERY_KEY = [
  'entityDetails',
  'entityDetailsRestApi',
  'summarySectionDetails',
];

export const GET_VERSIONS_QUERY_KEY = [
  'entityDetails',
  'entityDetailsRestApi',
  'versions',
];
export const CREATE_VERSION_QUERY_KEY = [
  'entityDetails',
  'entityDetailsRestApi',
  'createVersion',
];
export const ROLLBACK_VERSION_QUERY_KEY = [
  'entityDetails',
  'entityDetailsRestApi',
  'rollbackVersion',
];
export const GET_VERSIONS_COMPARISON_QUERY_KEY = [
  'entityDetails',
  'entityDetailsRestApi',
  'versionsComparison',
];
export const ACTIONABLES_QUERY_KEY = [
  'entityDetails',
  'entityDetailsRestApi',
  'actionables',
];
export const ENTITY_STATUS_QUERY_KEY = [
  'entityDetails',
  'entityDetailsRestApi',
  'entityStatus',
];

export const HISTORY_QUERY_KEY = [
  'entityDetails',
  'entityDetailsRestApi',
  'history',
];
export const LINKED_ENTITIES_TABLE_QUERY_KEY = [
  'entityDetails',
  'entityDetailsRestApi',
  'linkedEntitiesTable',
];

export const WORKFLOW_DRAWER_DETAILS_QUERY_KEY = [
  'entityDetails',
  'entityDetailsRestApi',
  'workflowDrawerDetails',
];
export const ONGOING_PROCESSES_QUERY_KEY = [
  'entityDetails',
  'entityDetailsRestApi',
  'ongoingProcesses',
];

export const ATTRIBUTE_SOURCE_MAPPING_QUERY_KEY = [
  'entityDetails',
  'entityDetailsRestApi',
  'attributeSourceMapping',
];
